import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { TEST_IDS } from "@/constants/testIds";

export default function Footer() {
    const { t } = useI18n();
    const l = t.landing.footer;
    const groups = [
        { title: l.product, links: [
            { k: "features", label: l.links.features, href: "#features" },
            { k: "pricing", label: l.links.pricing, href: "#pricing" },
            { k: "integrations", label: l.links.integrations, href: "#" },
            { k: "roadmap", label: l.links.roadmap, href: "#" },
        ]},
        { title: l.company, links: [
            { k: "about", label: l.links.about, href: "#" },
            { k: "blog", label: l.links.blog, href: "/blog" },
            { k: "contact", label: l.links.contact, href: "#" },
        ]},
        { title: l.legal, links: [
            { k: "privacy", label: l.links.privacy, href: "#" },
            { k: "terms", label: l.links.terms, href: "#" },
            { k: "rgpd", label: l.links.rgpd, href: "#" },
            { k: "dpa", label: l.links.dpa, href: "#" },
        ]},
    ];
    return (
        <footer className="relative border-t border-white/8 pt-16 pb-10 bg-brand-void">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
                    <div className="col-span-2">
                        <Link to="/" className="inline-flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg btn-cta flex items-center justify-center text-white font-black text-sm">B</span>
                            <span className="font-display font-black text-lg tracking-tight text-white">BOXEB2B</span>
                        </Link>
                        <p className="mt-4 text-sm text-zinc-500 max-w-sm leading-relaxed">{l.tagline}</p>
                    </div>
                    {groups.map((g) => (
                        <div key={g.title}>
                            <div className="text-xs uppercase tracking-[0.18em] font-bold text-zinc-500">{g.title}</div>
                            <ul className="mt-4 space-y-2.5">
                                {g.links.map((li) => (
                                    <li key={li.k}>
                                        <a
                                            href={li.href}
                                            data-testid={TEST_IDS.landing.footerLink(li.k)}
                                            className="text-sm text-zinc-300 hover:text-white transition"
                                        >
                                            {li.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div className="text-xs text-zinc-500">{l.rights}</div>
                    <div className="text-xs font-mono text-zinc-500">v0.1.0 · Phase 1</div>
                </div>
            </div>
        </footer>
    );
}
